/*
 * @Description: 混入websocket
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2023-05-26 13:23:25
 * @LastEditTime: 2024-06-24 17:28:18
*/
// import Speech from 'speak-tts'
const wsMixin = {
  data() {
    return {
      ws: null,
      alarmList: [],
      heartCheck: {},
      isOnline: true,
      isAlarmShow: true,
      audio: null,
      audioDemo: null,
      speecher: null,
      speech: null,
      isMp3: true
    }
  },
  created() {

    let alarmList = this.resetGetItem('alarmList')
    // let alarmList = JSON.parse(window.localStorage.getItem('alarmList'))
    this.alarmList = alarmList || []

    this.createWebSockets()
    window.addEventListener('setItem', () => {
      let newValue = this.resetGetItem('alarmList')
      // let newValue = JSON.parse(localStorage.getItem('alarmList'))
      // console.log(1123, newValue)
      this.alarmList = newValue || []
    })
  },
  mounted () {
    let isMp3 = JSON.parse(window.localStorage.getItem('isMp3'))
    this.isMp3 = isMp3 == null ? true : isMp3
    this.audioDemo = this.$root.$children[0].audioDemo
  },
  methods: {
    /**
     * @description: 长连接
     * @param        {[type]} code [description]
     * @return       {[type]}      [description]
     */
    createWebSockets () {
      const { ws } = this
      ws && ws.close()
      let tenant = this.storage.getSession("tenant") ? 1 : 2
      // console.log(11223, tenant)

      let random = `${new Date().getTime()}${Math.floor((Math.random() * 8999 + 1000))}`
      // let random = `${Math.floor((Math.random() * 8999 + 1000))}`

      // let wsUri = `${location.protocol.startsWith('https:') ? 'wss' : 'ws'}://${
      //   location.host
      // }/api2/notify/webSocket/${tenant}/${this.storage.getSession("userId")}`

      let wsUri = `${location.protocol.startsWith('https:') ? 'wss' : 'ws'}://${
        location.host
      }/api2/topic/notify/webSocket/${tenant}/${this.storage.getSession("userId")}/${random}`

      const websocket = new WebSocket(wsUri)
      //心跳检测
      this.heartCheck = {
        timeout: 30000,        //40s发一次心跳
        timeoutObj: null,
        serverTimeoutObj: null,
        reset: function(){
          clearTimeout(this.timeoutObj);
          clearTimeout(this.serverTimeoutObj);
          return this;
        },
        start: function(){
          var self = this;
          this.timeoutObj = setTimeout(function(){
              //这里发送一个心跳，后端收到后，返回一个心跳消息，
              //onmessage拿到返回的心跳就说明连接正常
              websocket.send("ping");
              console.log("ping!")
              self.serverTimeoutObj = setTimeout(function(){//如果超过一定时间还没重置，说明后端主动断开了
                websocket.close();     //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
              }, self.timeout)
          }, this.timeout)
        }
      }
      websocket.onerror = e => {
        console.log('websocket通信失败!', e)
        this.isOnline = false
        // this.$notify({ title: '警告', message: '通信断开，无法正常接收报警信息！请刷新重试或联系管理员！', type: 'warning' });
        // this.createWebSockets()
      }

      websocket.onopen = () => {
        console.log('开始')
        // websocket.send()
        this.heartCheck.reset().start();      //心跳检测重置
        this.$notify({ title: '成功', message: '通信连接正常！', type: 'success' });
        this.flag = 0
        
        this.isOnline = true
      }

      websocket.onclose = () => {
        console.log('结束')
        this.isOnline = false
        this.isAlarmShow && this.createWebSockets()
        !this.flag && this.$notify({ title: '警告', message: '通信断开，无法正常接收报警信息！请刷新重试或联系管理员！', type: 'warning' });
        this.flag = 1
      }

      websocket.onmessage = e => {
        this.heartCheck.reset().start();      //心跳检测重置
        if(e.data != 'pong'){
          let info = JSON.parse(e.data)
          // if (info.type == 'New') return
          if (info.type == 'Camera') {
            this.isVideo = true

            let src = info.data
            let index = info.index
            let len = this.videoItemConfig.length
            this.videoItemConfig.push({
              videoContainerId: `videoContainer${index}`,
              videoId: `video${index}`
            })
            this.initVideo(info.data, len)
          } else if (info.type != 'New'){
            // 解析数据
            // 保证只展示四条报警弹框
            if (this.alarmList.length >= 4) this.alarmList.pop()
            this.alarmList.unshift(info.data)
            let alarmListTemp = JSON.stringify(this.alarmList)
            // sessionStorage.setItem('alarmList', alarmListTemp)
            this.resetSetItem('alarmList', alarmListTemp, 7)

            // 安前宾 2023-11-06 让关闭：原因服务器顶不住
            // this.getStaticData()

            // 播报语音
            if (this.isAlarmShow) {
              if (this.isMp3) {
                this.playAudio()
              } else {
                let msg = info.data.content
                this.speaking(msg)
              }

              // let OS = this.detectOS()

              // if (OS === 'Win7') {
              //   // this.baiduSpeak(info.data.content)
              //   this.speaking(info.data.content)
              // } else {
              //   if (this.myBrowser() == "Chrome") {
              //     this.speaking(info.data.content)
              //   } else {
              //     this.broadcast(info.data.content)
              //   }
              // }
            }
          }
        }
      }

      this.ws = websocket
    },
    baiduSpeak(msg) {
      let baseUrl = window.location.origin
      // 百度文字转语音播报
      // let url = baseUrl + '/front/text2audio?cuid=baike&lan=ZH&ctp=1&pdt=301&vol=9&rate=32&per=0&tex=' + encodeURI(msg)
      // 搜狗文字转语音播报
      let url = baseUrl + '/reventondc/microsoftGetSpeakFile?from=translateweb&spokenDialect=zh-CHS&text=' + encodeURI(msg)
      if (this.audio === null) this.audio = new Audio()

      if (this.audio.paused) {
        this.audio.src = url
        this.audio.play()
      }
    },
    /**
     * @Description 判断用户的系统
     * @Author      YOYO     -             2022-03-18
     * @return      {string} [系统]
     */
    detectOS() {
      var sUserAgent = navigator.userAgent;
       
      var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
      var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
      if (isMac) return "Mac";
      var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
      if (isUnix) return "Unix";
      var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
       
      var bIsAndroid = sUserAgent.toLowerCase().match(/android/i) == "android";
      if (isLinux) {
      if(bIsAndroid) return "Android";
      else return "Linux";
      }
      if (isWin) {
      var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
      if (isWin2K) return "Win2000";
      var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 ||
      sUserAgent.indexOf("Windows XP") > -1;
      if (isWinXP) return "WinXP";
      var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
      if (isWin2003) return "Win2003";
      var isWinVista= sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
      if (isWinVista) return "WinVista";
      var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
      if (isWin7) return "Win7";
      }
      return "other";
    },
    /**
     * @Description 检测当前浏览器
     */
    myBrowser() {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
      var isIE = userAgent.indexOf("compatible") > -1
              && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
      var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
      var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
      var isSafari = userAgent.indexOf("Safari") > -1
              && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
      var isChrome = userAgent.indexOf("Chrome") > -1
              && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

      if (isIE) {
          var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
          reIE.test(userAgent);
          var fIEVersion = parseFloat(RegExp["$1"]);
          if (fIEVersion == 7) {
              return "IE7";
          } else if (fIEVersion == 8) {
              return "IE8";
          } else if (fIEVersion == 9) {
              return "IE9";
          } else if (fIEVersion == 10) {
              return "IE10";
          } else if (fIEVersion == 11) {
              return "IE11";
          } else {
              return "0";
          }//IE版本过低
          return "IE";
      }
      if (isOpera) {
          return "Opera";
      }
      if (isEdge) {
          return "Edge";
      }
      if (isFF) {
          return "FF";
      }
      if (isSafari) {
          return "Safari";
      }
      if (isChrome) {
          return "Chrome";
      }  
    },
    broadcast(test) {
      console.log(123123)
      var msg = new SpeechSynthesisUtterance(test)
      msg.lang = 'zh-CN';
      msg.rate = 1
      speechSynthesis.speak(msg)
      msg.onerror = (event) => {
        console.error('无法播放语音，可能的原因是：', event);
       
      }
    },
    speaking (params) {
      this.audioDemo && this.audioDemo.pause()
      if (!('speechSynthesis' in window)) {
        console.error('您的浏览器不支持语音合成。')
      }

      this.speecher = window.speechSynthesis

      if (this.speecher.speaking) {
        this.speecher.cancel()
      }

      const voices = this.speecher.getVoices()

      let utterThis = new SpeechSynthesisUtterance(params)

      // utterThis.rate = '1.2'

      // for (let i = 0; i < voices.length; i++) {
      //   if (voices[i].name === 'Microsoft Huihui - Chinese (Simplified, PRC)') {
      //     utterThis.voice = voices[i];
      //     break;
      //   }
      // }
      this.speecher.speak(utterThis)
    },
    playAudio() {
      this.speecher && this.speecher.cancel()

      if (!this.audioDemo) return
      this.audioDemo.currentTime = 0;
      this.audioDemo.play().catch(error => {
        console.error('无法播放语音，可能的原因是(无用户交互)：', event);
      })
    },
  }
}
export default wsMixin;
